import { Reveal } from "@/components/site/Reveal";

export const HomeIntro = () => (
  <section className="bg-white py-20 md:py-32" data-testid="home-intro">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 grid gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-3">
        <p className="eyebrow text-[var(--green)]">About us</p>
        <div className="mt-6 hidden lg:block h-px w-24 bg-[var(--navy)]" />
      </Reveal>
      <div className="lg:col-span-9">
        <Reveal>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.15] text-[var(--navy)]">
            Easy Handyman Services makes looking after your property simple – with
            <span className="font-accent font-normal text-[var(--green)]"> convenient, dependable </span>
            help for your home, garden and everything in between.
          </h2>
        </Reveal>
        <div className="mt-12 grid gap-8 md:grid-cols-2 text-[var(--body)] leading-relaxed">
          <Reveal delay={0.1}>
            <p>
              We're a friendly property maintenance company offering handyman services across Oxfordshire. Instead of
              finding a decorator, a gardener and a cleaner separately, you can call one team that takes care of it all.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p>
              From interior painting and insulation to lawn care, driveway pressure washing, deep cleaning and carpet
              cleaning, we help Oxfordshire homeowners maintain and improve their properties – with free quotations on every job.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
